import { components } from "@/api-schema";
import { RELOCATION_ORDER_STATUS_FILTER_OPTIONS } from "@/components/filter/predefined/relocation-order-status-filter";
import { RowAction, RowActionVariant } from "@/components/ui/table-row-actions";
import { CheckIcon, WrenchIcon } from "lucide-react";
import { RelocationOrderActionsContext } from "@/common/hooks/relocation-order/_helpers/relocation-order-actions-context";
import { isBranchRejectedStatus, isTransportCompanyRejectedStatus } from "./relocation-order-status-predicates";

type RelocationOrder = components["schemas"]["RelocationOrder"];

export function buildManagingBranchByTransportCompanyActions(
  order: RelocationOrder,
  context: RelocationOrderActionsContext,
): RowAction[] {
  const actions: RowAction[] = [];

  const { status } = order;
  const vehicleIsBlocked = !!order.vehicle?.vehicleBlock;

  if (isBranchRejectedStatus(status)) {
    actions.push({
      label: context.t("fit:FixProblem"),
      icon: <WrenchIcon className="h-4 w-4" />,
      onClick: () => context.handleResolveBranchRejectedIssue(order),
    });
  }

  if (isTransportCompanyRejectedStatus(status)) {
    actions.push({
      label: context.t("fit:FixProblem"),
      icon: <WrenchIcon className="h-4 w-4" />,
      onClick: () => context.handleResolveTransportCompanyIssue(order),
    });
  }

  if (status === RELOCATION_ORDER_STATUS_FILTER_OPTIONS.Transport_Company_Awaiting_Ready_For_Transport.id) {
    actions.push({
      label: context.t("fit:ApproveTransport"),
      icon: <CheckIcon className="h-4 w-4" />,
      variant: RowActionVariant.Success,
      disabled: vehicleIsBlocked,
      onClick: () => context.handleApproveReadyForTransport(order),
    });
  }

  return actions;
}
